class EqualHeight {

	constructor(blockEl) {
		this.el = blockEl;
		this.targets = this.el.querySelectorAll('.equal-height-target');
		this.handleResize = this.debounce(this.onResize.bind(this), 150);

		this.init();
		this.bindEvents();
	}

	async init() {
		const maxHeight = await this.getHeights();
		this.equalizeHeights(maxHeight);
	}

	bindEvents() {
		window.addEventListener('resize', this.handleResize);
	}

	destroy() {
		window.removeEventListener('resize', this.handleResize);
	}

	async getHeights() {
		let maxHeight = 0;
		this.targets.forEach(target => {
			// Temporarily drop aspect-ratio so overflowing content (e.g. link-cards)
			// is included in the measured height instead of being clipped.
			const previousAspectRatio = target.style.aspectRatio;
			target.style.aspectRatio = 'auto';
			const targetHeight = target.offsetHeight;
			target.style.aspectRatio = previousAspectRatio;

			if (targetHeight > maxHeight) {
				maxHeight = targetHeight;
			}
		});

		return maxHeight;
	}

	equalizeHeights(maxHeight) {
		this.targets.forEach(target => {
			// minHeight lets aspect-ratio cards grow when copy needs more room
			target.style.height = '';
			target.style.minHeight = maxHeight + 'px';
		});
	}

	async onResize() {
		this.targets.forEach(target => {
			target.style.height = '';
			target.style.minHeight = '';
		});

		const maxHeight = await this.getHeights();
		this.equalizeHeights(maxHeight);
	}

	debounce(fn, delay) {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => fn.apply(this, args), delay);
		};
	}

}

export default EqualHeight;
